<h3 mat-dialog-title>{{ 'tours.confirmation.title' | translate }}</h3>

<mat-dialog-content fxLayout="column" fxLayoutGap="1rem">
  <h5 class="confirmation-text">{{ 'tours.confirmation.text' | translate }}</h5>
  <div class="confirmation-data">
    <div>{{ 'core.customer' | translate }}:</div>
    <div>{{ data.tour.customer.code }}</div>

    <div>{{ 'core.constructionSite' | translate }}:</div>
    <div>{{ data.tour.constructionSite.name }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="false" color="secondary">
    {{ 'core.cancelBtn' | translate }}
  </button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">
    {{ 'core.deleteBtn' | translate }}
  </button>
</mat-dialog-actions>
